import React, { useEffect, useState } from 'react';

import { DropDownList } from '@progress/kendo-react-dropdowns';
import { Grid, GridColumn as Column } from '@progress/kendo-react-grid';
import { Dialog } from '@progress/kendo-react-dialogs';

import { Content, Header, PageContainer } from '../Drawer/PageContainer';
import Alice from "../Display/Alice"

import { callApiWithAuthorization } from '../../API/CallApi';
import { getProject, updateProject } from '../../API/Project/project';
import { compressArtifacts, decompressArtifacts } from './utils';

function Artifacts({ projectId }) {

    const [loading, setLoading] = useState(true);
    const [instances, setInstances] = useState([]);
    const [error, setError] = useState(null);

    const [selectedInstance, setSelectedInstance] = useState({});

    const [isDeleteArtifactsVisible, setIsDeleteArtifactsVisible] = useState(false);

    useEffect(() => {
        getProject(projectId)
            .then(setData)
            .catch(err => setError(err.message))
            .finally(() => setLoading(false))
    });

    function setData(project) {
        if (project.instances.length > 0) {
            handleInstanceSelection(project.instances[0]);
        } else {
            setSelectedInstance({});
        }

        setInstances(project.instances)
    }
    
    //#region select instance dropdown
    function handleSelectedInstance(event) {
        handleInstanceSelection(event.target.value);
    }

    function handleInstanceSelection(instance) {
        const decompressedArtifacts = instance.artifacts ? decompressArtifacts(instance.artifacts) : [];
        setSelectedInstance({
            ...instance,
            artifacts: decompressedArtifacts
        });
    }
    //#endregion

    //#region deleteArtifacts
    function toggleDeleteDialog() {
        setIsDeleteArtifactsVisible(!isDeleteArtifactsVisible);
    }

    function deleteAllArtifacts() {
        //
    }
    //#endregion

    //#region get artifacts from runtime
    async function getArtifactsFromRuntime() {
        try {
            debugger;
            const getArtifactsRequest = await fetch(process.env.REACT_APP_RUNTIME_API_URL + "/api/ui/GetArtifacts", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "appid": selectedInstance._id
                }
            });

            const artifacts = await getArtifactsRequest.json();

            const compressedArtifacts = compressArtifacts(artifacts.data[0]);

            const newInstancesData = instances.map(instance => {
                if (instance._id === selectedInstance._id) {
                    return {
                        ...instance,
                        artifacts: compressedArtifacts
                    }
                }
                return instance;
            })

            await updateProject(projectId, { instances: newInstancesData });
        } catch (e) {
            console.error(e);
        }
    }
    //#endregion

    return (
        <PageContainer>
            {
                isDeleteArtifactsVisible &&
                <Dialog title="Delete Artifacts" onClose={this.toggleDeleteDialog}>
                    <p>
                        <i className="fas fa-exclamation-triangle" style={{ color: "#d67f3c", fontSize: "30px" }}></i>&nbsp;&nbsp;
                        Are you sure you want to delete all the last synced artifacts?
                    </p>
                    <div id="dialog_btnholder">
                        <button className="btn btn-secondary" onClick={this.deleteAllArtifacts}>Delete</button>
                        <button className="btn btn-primary" style={{ background: "#0078d4", color: "#fff" }} autoFocus onClick={this.toggleDeleteDialog}>Cancel</button>
                    </div>
                </Dialog>
            }
            <Header header={"Artifacts"} >
                <DropDownList
                    data={instances}
                    textField="instanceName"
                    value={selectedInstance}
                    onChange={handleSelectedInstance} />
                <button
                    className="btn btn-primary mx-3"
                    disabled={!selectedInstance._id}
                    onClick={getArtifactsFromRuntime} >
                    Sync Artifacts
                </button>
            </Header>
            <Content>
                {
                    (
                        selectedInstance.artifacts === undefined ||
                        selectedInstance.artifacts === null ||
                        selectedInstance.artifacts.length === 0
                    ) &&
                    <Alice>
                        <big>No artifacts are available at this moment</big>
                        <div>Setup a service on Runtime and than try to synchronize here</div>
                    </Alice>
                }
                {
                    selectedInstance.artifacts?.length > 0 &&
                    <>
                        <div>
                            <h6 className="headingh6">
                                {
                                    selectedInstance.artifacts.lastSyncedAt ?
                                        <>
                                            Last Synced from <b>{this.state.lastSyncedInstance.instanceName}</b>:
                                            &nbsp;
                                            {this.state.artifact.lastUpdatedOn.toString()}
                                        </>
                                        :
                                        "Please sync instance at least once"
                                }
                            </h6>
                        </div>
                        <div className="row about-project-card font-size-m">
                            <div className="col">
                                {
                                    loading ?
                                        // <Loader themeColor="primary" />
                                        <></>
                                        :
                                        <Grid
                                            data={selectedInstance.artifacts.map((artifact, i) => ({ ...artifact, _id: i + 1 }))}>
                                            <Column field="_id" title="#" width={50} />
                                            <Column field="type" title="Type" cell={props => (
                                                <td>List View</td>
                                            )} />
                                            <Column field="name" title="Name" />
                                            <Column field="info" title="Information" />
                                        </Grid>
                                }
                            </div>
                        </div>
                        <div>
                            <button
                                className="btn btn-outline-danger btn-sm"
                                onClick={toggleDeleteDialog}>
                                Delete all synchronized artifacts
                            </button>
                        </div>
                    </>
                }
            </Content>
        </PageContainer>
    )
    
}

export default Artifacts;